module.exports = __webpack_public_path__ + "img/storyboard_lite_slideshows.3070ca6a.webp";